/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import { Outlet } from "react-router-dom";
import styled from "styled-components";
import Anchor from "./components/ui/Anchor";
import { ROUTES } from "./constants/constants";
import T from "./components/ui/Translation";
import { useConfig } from "./lib/react-query/useConfig";
import { useSyncMembershipPrices } from "./hooks/useSyncMembershipPrices";
import MembershipServiceAccessModals from "./components/membership/MembershipServiceAccessModals";

const PersonalDataReportLink = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 3.5rem;
  text-align: center;
`;

const Layout = () => {
  const { data: config } = useConfig();

  useSyncMembershipPrices();

  return (
    <>
      <main>
        <Outlet />
        <MembershipServiceAccessModals />
      </main>
      {!config.hide_my_personal_data_upublic && (
        <PersonalDataReportLink>
          <Anchor underline="always" to={ROUTES.PERSONAL_DATA_REPORT}>
            <T>GDPR data</T>
          </Anchor>
        </PersonalDataReportLink>
      )}
    </>
  );
};

export default Layout;
